/**
 * RequestStatusService
 * Service for RequestStatus entity operations
 * Route: api/requeststatus
 * Controller: RequestStatusController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * RequestStatusService
 * Handles request status CRUD operations
 * Maps to /api/requeststatus endpoint
 */
export class RequestStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RequestStatusService.DEFAULT_SERVICE_PATH,
            basePath: RequestStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
RequestStatusService.DEFAULT_SERVICE_PATH = 'procurements';
RequestStatusService.BASE_PATH = 'api/requeststatus';
//# sourceMappingURL=RequestStatusService.js.map